import { render, staticRenderFns } from "./civilConfig.vue?vue&type=template&id=6e3cc878&scoped=true"
import script from "./civilConfig.vue?vue&type=script&lang=js"
export * from "./civilConfig.vue?vue&type=script&lang=js"
import style0 from "./civilConfig.vue?vue&type=style&index=0&id=6e3cc878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3cc878",
  null
  
)

export default component.exports